import { render, staticRenderFns } from "./NumerationsManager.vue?vue&type=template&id=1d95372a&scoped=true"
import script from "./NumerationsManager.vue?vue&type=script&lang=js"
export * from "./NumerationsManager.vue?vue&type=script&lang=js"
import style0 from "./NumerationsManager.vue?vue&type=style&index=0&id=1d95372a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d95372a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d95372a')) {
      api.createRecord('1d95372a', component.options)
    } else {
      api.reload('1d95372a', component.options)
    }
    module.hot.accept("./NumerationsManager.vue?vue&type=template&id=1d95372a&scoped=true", function () {
      api.rerender('1d95372a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/components/numerations/NumerationsManager.vue"
export default component.exports